export { AuthTokenService } from './auth-token.service';
export { AuthService } from './auth.service';
export { CertificatPositionnementService } from './certificat-positionnement.service';
export { LocalStorageService } from './local-storage.service';
export { ObjetsService } from './objets.service';




// WEBPACK FOOTER //
// ./src/app/shared/services/index.ts